import useEvent from '@lyearn/core/hooks/useEvent';
import { cn } from '@lyearn/style';
import { BaseButton } from '@lyearn/ui';

interface ENPSRatingItemProps {
  className?: string;
  value: number;
  isSelected?: boolean;
  onClick: (value: number) => void;
}

const classes = {
  root: 'min-w-0 rounded-none',
  selected: 'bg-focus-primary hover:bg-focus-primary text-text-white',
  unselected: 'bg-bg-secondary hover:bg-bg-onclick-dark text-text-secondary',
};

const ENPSRatingItem: React.FC<ENPSRatingItemProps> = (props) => {
  const { className, value, isSelected, onClick } = props;

  const onItemClick = useEvent(() => {
    onClick(value);
  });

  return (
    <BaseButton
      className={cn(className, classes.root, isSelected ? classes.selected : classes.unselected)}
      onClick={onItemClick}>
      {value}
    </BaseButton>
  );
};

export default ENPSRatingItem;
